// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"logo_scroll-black__1oDEv","logo":"logo_logo__SW71U","big":"logo_big__9O9bp"};